import PropTypes from "prop-types";
import styles from "./YearFilterDropdown.module.css";
import classNames from "classnames";
import downArrow from "./down-arrow.png";
import { useState } from "react";

/**
 * A dropdown that selects a year to filter out content on a page.
 */

export function YearFilterDropdown({ currentYear, yearOptions, onChangeYear }) {
  const [dropDownOpen, setDropDownOpen] = useState(false);

  function changeYear(year){
    onChangeYear(year);
    setDropDownOpen(false)
  }

  return (
    <>
      <div
        className={styles.button}
        onClick={() => setDropDownOpen(!dropDownOpen)}
      >
        {currentYear}
        <img className={styles.arrow} src={downArrow} />
      </div>

      {dropDownOpen ? (
        <div className={styles.dropdown}>
          {yearOptions.map((item) => ( <div key={item} className={classNames(styles.dropdownItem, item == currentYear ? styles.selectedDropdownItem : "")} onClick={() => changeYear(item)}>{item}</div>))}
        </div>
      ) : (
        ""
      )}
    </>
  );
}

YearFilterDropdown.propTypes = {
  currentYear: PropTypes.string, 
  yearOptions: PropTypes.arrayOf(PropTypes.string), 
  onChangeYear: PropTypes.func, 
};
